import React, { useState } from 'react';

import { useClassName } from 'common/hooks';

import Center from '../Center';
import Card from '../Card';
import useCustomStyle from '../../hooks';
import { appendStylesByPrefix } from '../../utils';

import './collapsible-list.less';

export default function CollapsibleList({ component, refs, handleTrack }) {
  const classNames = useClassName('CLPCollapsibleList');
  const [setRef, style] = useCustomStyle(component.fields.settings);
  const [activeIndex, setActiveIndex] = useState(0);
  const items = component.fields.items;

  const containerStyle = Object.fromEntries(
    Object.entries(style)
      .filter(([k]) => k.startsWith('--container-'))
      .map(([k, v]) => [k.replace('--container-', ''), v])
  );

  return (
    <div style={containerStyle}>
      <Center className={classNames(['container'])} ref={setRef}>
        {items.map((item, index) => (
          <Card
            key={item.sys.id}
            item={appendStylesByPrefix(component, item, '--card-')}
            refs={refs}
            handleTrack={handleTrack}
            isActive={activeIndex === index}
            onSelect={() => setActiveIndex(index)}
          />
        ))}
      </Center>
    </div>
  );
}
